import AppContext, {IAppContext, IAppV2Context} from "../../../../componentsApp/context/AppContext";
import React, {useContext, useEffect, useState} from "react";
import WindowWrapper from "../../../layouts/WindowLayout";
import Spaces from "../../Spaces";
import {abstractPostFetch, abstractPutFetch} from "../../../../../utils/abstractFetch";
import ButtonWrapper from "../../../layouts/ButtonWrapper";
import {capitalizeMulti} from "../../../../../utils/converters";
import {useForm} from "use-formidable";
import {devLog} from "../../../../../utils/devLog/devLog";
import {notification} from "../../../../../utils/notification";
import axios from "axios";
import CandidateWindowV2Profile from "./componentsCWV2/CandidateWindowV2Profile";
import CandidateWindowV2Loading from "./componentsCWV2/CandidateWindowV2Loading";
import CandidateWindowV2Navbar from "./componentsCWV2/CandidateWindowV2Navbar";
import CandidateWindowV2Content from "./componentsCWV2/CandidateWindowV2Content";

export default function(props: any) {
  
  const appContextV2: IAppV2Context = useContext(AppContext) as IAppV2Context || {};
  
  const [candidate, setCandidate] = useState({
    candidate: {},
    candidacy: {
      _id: "",
    }
  });
  const [windowStatus, setWindowStatus] = useState("asleep");
  const [dictionaries, setDictionaries] = useState({});
  const [page, setPage]: ["" | "cv" | "doc" | "profile" | "results" | "trigram" | "mail" | "history", Function] = useState("");
  
  devLog("candidate", candidate);
  devLog("window's page", page);
  devLog("dictionaries", dictionaries);
  
  const inherited = {
    category: appContextV2.appPanels.window.windowOptions.data.category, // mission or pool
    keywords: appContextV2.appPanels.window.windowOptions.data.keywords,
    candidateId: appContextV2.appPanels.window.windowOptions.data.candidateId,
    missionId: appContextV2.appPanels.window.windowOptions.data.missionId,
    basicData: appContextV2.appPanels.window.windowOptions.data.basicData,
    frontUpdatePool: appContextV2.appPanels.window.windowOptions.data.frontUpdatePool,
    frontUpdateMission: appContextV2.appPanels.window.windowOptions.data.frontUpdateMission,
  };
  
  useEffect(() => {
    if(inherited.category === "pool") setPage("cv");
    if(inherited.category === "mission") setPage("results");
  }, []);
  
  useEffect(() => {
    (async() => {
      const fetched = await axios.get(`${process.env.REACT_APP_API_URL}/data/get/dictionaries/full`, {
        timeout: 20_000,
        withCredentials: true
      });
      if(fetched.data.status === "ok") {
        setDictionaries(fetched.data.data);
      }
    })();
  }, []);
  
  useEffect(() => {
    (async() => {
      try {
        setWindowStatus("fetching");
        const fetched = await axios.get(`${process.env.REACT_APP_API_URL}/pool/cm/candidate/v2`, {
          timeout: 20_000,
          headers: {
            candidateid: inherited.candidateId,
            missionid: inherited.missionId,
            category: inherited.category,
          },
          withCredentials: true
        });
        if(fetched.data.status !== "ok") {
          setWindowStatus("error");
          return notification(appContextV2.dispatchPanels, "Une erreur est survenue", "error");
        }
        setCandidate(fetched.data.data);
        setWindowStatus("fetched");
      } catch (error) {
        devLog(error);
        setWindowStatus("fetched");
        return notification(appContextV2.dispatchPanels, "Une erreur est survenue", "error");
      }
    })();
  }, []);
  
  const updateCandidateFrontInWindow = (keyValuePairs: any) => {
    setCandidate((ps: any) => ({
      ...ps,
      candidate: {
        ...ps.candidate,
        ...keyValuePairs
      }
    }));
    // Update front in pool and mission
    inherited.frontUpdatePool?.updateCandidatesBulk([inherited.candidateId], {...keyValuePairs});
    //inherited.frontUpdateMission?.updateCandidaciesBulk([candidate?.candidacy?._id], {...keyValuePairs});
  }
  
  const toggleAvailability = () => {
    setCandidate((ps: any) => ({
      ...ps,
      candidate: {
        ...ps.candidate,
        isListeningToMarket: !ps.candidate.isListeningToMarket
      }
    }));
  }
  
  return (<WindowWrapper size={"bigger"} status={"ok"} windowTitle={""}>
    
    <section className={"window-candidate-v2"}>
    
      <article className={`window-candidate-v2__body`}>
        
        {["asleep", "fetching"].includes(windowStatus) && <CandidateWindowV2Loading/>}
        
        {["fetched", "error"].includes(windowStatus) && <>
          
          <CandidateWindowV2Navbar inherited={inherited} page={page} setPage={setPage}/>
          
          <Spaces n={2}/>
          
          <CandidateWindowV2Content page={page}
                                    dictionaries={dictionaries}
                                    candidate={candidate}
                                    inherited={inherited}
                                    updateCandidateFrontInWindow={updateCandidateFrontInWindow}
                                    setCandidate={setCandidate}/>
        </>}
        
      </article>
      <article className={"window-candidate-v2__nav"}>
        
        <CandidateWindowV2Profile candidate={candidate}
                                  inherited={inherited}
                                  toggleAvailability={toggleAvailability}
                                  updateCandidateFrontInWindow={updateCandidateFrontInWindow}
                                  windowStatus={windowStatus}/>
                                  
      </article>
      
    </section>
  
  </WindowWrapper>);
}
